import classNames from 'classnames';
import type { FC } from 'react';
import type { Tailwind } from 'styles/tw';

type Props = {
  text: string;
  conditionsFlexDirection: Tailwind['flexDirection'];
  containerBackground?: string;
  width?: Tailwind['width'];
  height?: Tailwind['height'];
  borderColor?: Tailwind['borderColor'];
  borderWidth?: Tailwind['borderWidth'];
};

export const TextContainer: FC<Props> = ({
  containerBackground,
  width = 'w-full',
  height = 'h-auto',
  borderColor = 'border-transparent',
  borderWidth = 'border-2',
  text,
  conditionsFlexDirection
}) => (
  <div
    className={classNames(
      'flex justify-center items-center max-w-[350px] min-h-[96px] xs:min-h-[120px] py-4 px-6 bg-center rounded-sm border-solid bg-no-repeat bg-contain',
      `${conditionsFlexDirection === 'flex-col' ? 'semiLg:max-w-[918px] semiLg:min-h-[108px] semiLg:h-[108px]' : ''}`,
      width,
      height,
      borderColor,
      borderWidth
    )}
    style={{
      background: containerBackground || 'none'
    }}
  >
    <p className="text-sm xxs:text-base xs:text-lg text-center">{text}</p>
  </div>
);
